export default __webpack_public_path__ + "static/media/Kulthum.22c85637.jpg";